import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip'
import type * as React from 'react'
import { cn } from '../lib/cn'
import { Kbd } from './kbd'

export function TooltipProvider({ delay = 300, ...props }: TooltipPrimitive.Provider.Props) {
  return <TooltipPrimitive.Provider delay={delay} {...props} />
}

/**
 * Hover hint. Pass `keys` and the hint shows the chord, which is how "every key has a button" and
 * "hover on any button shows its key" (scope §5.0) stay true.
 */
export function Tooltip({
  content,
  keys,
  side = 'top',
  children,
}: {
  content: React.ReactNode
  keys?: string
  side?: TooltipPrimitive.Positioner.Props['side']
  children: React.ReactElement
}) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger render={children} />
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Positioner side={side} sideOffset={6} className="z-50">
          <TooltipPrimitive.Popup
            role="tooltip"
            className={cn(
              'flex items-center gap-2 rounded-md bg-foreground px-2 py-1 text-xs text-background shadow-md',
              'origin-(--transform-origin) transition-[opacity,transform] duration-(--duration-fast) data-[ending-style]:opacity-0 data-[starting-style]:scale-95 data-[starting-style]:opacity-0',
            )}
          >
            {content}
            {keys ? <Kbd keys={keys} className="[&_kbd]:border-transparent [&_kbd]:bg-background/15 [&_kbd]:text-background" /> : null}
          </TooltipPrimitive.Popup>
        </TooltipPrimitive.Positioner>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
